// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"a07b6b0e","287":"342b5e8d","290":"80b33e22","344":"e4edd229","550":"ea8f083f","608":"5d37edf5","841":"a0563c66"}[chunkId] + ".chunk.js";
};